import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { deleteTask } from 'api/task.service';
import { useToast } from 'hooks/ui';
import { useNavigate } from 'react-router-dom';
import { deleteDraft } from 'store/task.store';
import { Task } from 'models/task.model';

export const useTaskDeleteQuery = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isLoading, isError, mutate } = useMutation(
    ({ id }: { id: string }) => deleteTask(id),
    {
      retry: false,
      onSuccess: (task: Task) => {
        queryClient.invalidateQueries(['tasks']);
        queryClient.invalidateQueries(['tasks', task.id]);
        deleteDraft(task.id);
        navigate('/tasks');
        toast.success('Task deleted successfully');
      },
      onError: (error: AxiosError) => {
        toast.error(error.message);
      },
    },
  );

  return { isLoading, isError, mutate };
};
